<div class="content-inner-deprecated pp-container">
    <div class="row wrap-section">
        <div class="col-xl-4 offset-xl-4 col-lg-4 offset-lg-4 col-md-6 offset-md-3 col-sm-12 col-xs-12">

            <pp-login-box [showRegister]="false"></pp-login-box>

        </div>
    </div>
</div>
